module.exports = __webpack_public_path__ + "img/ren_1.1653e60c.webp";